import css from 'styled-jsx/css';

const styles = css.global`.c2c-black-bg {
  /* background: linear-gradient(0deg, #222222, #222222),
    linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)); */

  background: #181818;
  padding: 24px 0 56px;
  overflow: hidden;
  position: relative;
}

.c2c-black-bg .c2c-bg-title {
  color: #fff;
  /* Heading 768/H1. 768 pxw */
  font-family: 'SantanderHeadline';
  font-size: 40px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px; /* 150% */
  margin-top: 64px;
  margin-bottom: 40px;
}

@media (min-width: 992px) {
  .c2c-black-bg .c2c-bg-title {
    margin-top: 88px;
  }

  .c2c-black-bg .c2c-bg-title br {
    display: none;
  }

  .c2c-bg-title .c2c-bg-title {
    margin-top: 88px;
    margin-bottom: 40px;
    text-align: left;
  }

  .c2c-black-bg {
    padding-top: 113px;
    padding-bottom: 113px;
  }
}
`;

export default styles;